import React from 'react';
import firebase from 'firebase';
import { useHistory } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

function AuthNavigation ({ user: { name } }) {
  const history = useHistory();

  const redirectToLogin = async () => {
    await firebase.auth().signOut();
    history.push('/login');
  };

  return (
    <Nav className="ml-auto" navbar>
      <NavItem>
        <NavLink href="/orders">Orders</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href="/users">Users</NavLink>
      </NavItem>
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          {name.first} {name.last}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={redirectToLogin}>
            Log Out
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </Nav>
  );
}

export default AuthNavigation;
